import React from "react";

export const tourGuideSteps = [
  {
    selector: "#create-report-button",
    content: 
      "Clicking this button will take you to the page allowing you to create various reports about your environments.",
  },
  {
    selector: "#Report-Tasks-column-0",
    content:
      "Select reports to perform actions on them using the \"Report Action\" button below.",
  },
  {
    selector: "#Report-Tasks-column-1",
    content:
      "The read status for the report. Reports initially show up as unread and you can change their status by selecting a report and using the \"Reports Action\" button below.",
  },
  {
    selector: "#Report-Tasks-column-2",
    content:
      "This column shows the name of the report templates. All reports for the same template share data columns, but can have different run time search criteria.",
  },
  {
    selector: "#Report-Tasks-column-3",
    content:
      "Download a report directly.",
  },
  {
    selector: "#Report-Tasks-column-4",
    content: () => (
      <div>
        Various report statuses include:
        <ul>
          <li>COMPLETE: Report has executed and finished successfully</li>
          <li>EXECUTING: Report is being run</li>
          <li>ERROR: Report failed</li>
          <li>SCHEDULED: Report is scheduled to run at a future date or time</li>
          <li>PENDING: : Report is about to run</li>
        </ul>
      </div>
    ),
  },
  {
    selector: "#reports-action-select",
    content: () => (
      <div>
        Perform various actions on selected reports including:
        <ul>
          <li>Mark Selected Read: Set the selected reports to have a read status. They will no longer show up in your user notification badge</li>
          <li>Mark Selected Unread: Set the selected reports to have an unread status. They will show up in your user notification badge</li>
          <li>Download Selected: Download the selected reports to view them locally</li>
        </ul>
      </div>
    ),
  },
];
